import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fdae89a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TestResultGridSampleColumn" }
const _hoisted_2 = { class: "Text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "KindOfSample" }
const _hoisted_5 = {
  key: 0,
  class: "TextFeedback"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "List"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSVG = _resolveComponent("InlineSVG")!
  const _component_PaneLink = _resolveComponent("PaneLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["ListHead", { IsLastColumn: _ctx.isLastColumn }])
    }, [
      _createVNode(_component_PaneLink, {
        class: _normalizeClass(["SampleLink", _ctx.sample.getOverallResultClass()]),
        "pane-id": _ctx.linkedSampleID
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_ctx.fullSampleTitle), 1),
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.kindOfSampleText), 1)
          ]),
          (_ctx.linkedSampleID)
            ? (_openBlock(), _createBlock(_component_InlineSVG, {
                key: 0,
                class: "Icon",
                src: require('@/assets/svg/angle-right.svg')
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class", "pane-id"])
    ], 2),
    (_ctx.sampleType === 'existing')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('EXISTING_SAMPLE_FROM_EXTERNAL_PROJECT')), 1),
          _createElementVNode("p", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.mixWB('RESULT')), 1),
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_ctx.sample.getResultLabel()), 1)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.mixWB('REFERENCE')), 1),
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(_ctx.sample.existingResultExplanation), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.analysisTestListResults, (result) => {
            return (_openBlock(), _createElementBlock("div", {
              key: result.id,
              class: "ListCell"
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(result.class)
              }, _toDisplayString(result.text), 3)
            ]))
          }), 128))
        ]))
  ]))
}